const borderRadiuses = {
  BORDER_TOP_LEFT_RADIUS: 'border-top-left-radius',
  BORDER_TOP_RIGHT_RADIUS: 'border-top-right-radius',
  BORDER_BOTTOM_LEFT_RADIUS: 'border-bottom-left-radius',
  BORDER_BOTTOM_RIGHT_RADIUS: 'border-bottom-right-radius',
};

const paddings = {
  PADDING_TOP: 'padding-top',
  PADDING_BOTTOM: 'padding-bottom',
  PADDING_LEFT: 'padding-left',
  PADDING_RIGHT: 'padding-right',
};

const gaps = {
  COLUMN_GAP: 'column-gap',
  ROW_GAP: 'row-gap',
};

const alignments = {
  HORIZONTAL_ALIGNMENT: 'alignment',
  VERTICAL_ALIGNMENT: 'v-alignment',
  HORIZONTAL_ALIGN: 'h-align',
  VERTICAL_ALIGN: 'v-align',
};

export default {
  ...borderRadiuses,
  ...paddings,
  ...gaps,
  ...alignments,
  SURFACE: 'surface',
  BORDER: 'border',
  SHADOW: 'shadow',
  NO_WRAP: 'no-wrap',
  LAYOUT: 'layout',
  WIDTH: 'width',
  HEIGHT: 'height',
};
